import type { KeyboardEvent } from "react";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import { useDarkMode } from "../../hooks/useDarkMode";

function ThemeToggle() {
  const [theme, setTheme] = useDarkMode();
  const isDark = theme === "dark";

  const handleKeyDown = (event: KeyboardEvent<SVGElement | HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setTheme(isDark ? "light" : "dark");
    }
  };

  return (
    <DarkModeSwitch
      checked={isDark}
      onChange={(checked) => setTheme(checked ? "dark" : "light")}
      size={20}
      sunColor="#e8a33d"
      moonColor="#1d63c9"
      role="switch"
      aria-checked={isDark}
      aria-label="Dark mode"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    />
  );
}

export default ThemeToggle;
